/*
 * @Author: your name
 * @Date: 2021-05-28 20:18:01
 * @LastEditTime: 2025-07-22 10:52:48
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @Description: In User Settings Edit
 * @FilePath: \epec-ea\src\modules\projectA\store\action.js
 */
import VueCookies from 'vue-cookies';
import Api from '@/modules/projectA/api/dataCenter';
import { timestampToTime } from '@/modules/projectA/utils/utils';
import api_authority from '@/modules/projectA/api/authority';
import api from '../api/login';
import router from '../router/router.js';
import { secure } from '../api/config';
import whiteUtils from '../utils/isNanJingWhite';

function createKey() {
  const s = [];
  const hexDigits = '0123456789abcdef';
  for (let i = 0; i < 36; i++) {
    s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
  }
  s[14] = '4';
  s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1);
  s[8] = s[13] = s[18] = s[23] = '-';
  return s.join('');
}

function getDate() {
  const data = new Date();
  console.log(data.getMonth());
  console.log(data.getDate());
  const fullYear = data.getFullYear();
  const month =
    data.getMonth() + 1 > 9 ? data.getMonth() + 1 : `0${data.getMonth() + 1}`;
  const day = data.getDate() > 9 ? data.getDate() : `0${data.getDate()}`;
  return `${fullYear}-${month}-${day}`;
}

export default {
  getObjById(list, id) {
    if (!(list instanceof Array)) return null;
    for (const i in list) {
      const item = list[i];
      if (item.id === id) return item;

      if (item.children) {
        const obj = getObjById(item.children, id);
        if (obj) return obj;
      }
    }
  },
  get_userInfo: (state) => {
    return state.USERINFO;
  },
  // 获取用户菜单集合
  async get_menuList(context) {
    const res = await api.getAllMeunList();
    context.commit('get_menuList', res.data);
  },
  async getData_userInfo(context) {
    const token = VueCookies.get('epecToken');
    // if(token && !getStore('USERINFO')){
    if (token) {
      const res = await api.getLoginInfo();
      const { data } = res;
      // console.log('111111111111111111111111111')
      if (res.code == 200) {
        res.data.time = new Date().getTime();
        // 不是接口过来的用户  去除cookie epecUrlToRedirectAfterLogout
        if (!(data?.memberSource === 'zhongjian')) {
          VueCookies.remove('epecUrlToRedirectAfterLogout', {
            domain: '.epec.com',
            path: '/',
            secure: true,
          });
        }
        context.commit('update_userInfo', res.data);


        VueCookies.set('userInfo', res.data, null, '/', '.epec.com', secure);

        let nanJingWhiteData = false;
        const nanJingRes = await api_authority.isNanJingWhite(); // 南京白名单
        if (nanJingRes && nanJingRes.code === '200') {
          nanJingWhiteData = nanJingRes.data || false;
        }

        localStorage.setItem('nanJingWhiteData', nanJingWhiteData);

        if (
          res.data.purchaseAreaFlag &&
          res.data.purchaseAreaCompanyId === res.data.companyId
        ) {
          const res1 = await Api.memberMenuTree();

          const arr = [];
          const resolveList = res1.data.purchaseAreaTreeVo?.childList || [];
          for (let i = 0; i < resolveList.length; i++) {
            const item = resolveList[i];
            if (item.authName === '会员中心') {
              continue;
            }
            arr.push(item);
          }
          res1.data.purchaseAreaTreeVo.childList = arr;
          res1.data.purchaseAreaTreeVo.isPurchase = true;

          if (nanJingWhiteData) {
            // 配置南京白名单，直接存储
            context.commit('update_menuInfo', res1.data.purchaseAreaTreeVo);
          } else {
            // 没配置南京白名单，剔除
            const purchaseAreaTreeVo = whiteUtils.dealNanJingWhite(
              res1.data.purchaseAreaTreeVo
            );
            context.commit('update_menuInfo', purchaseAreaTreeVo);
          }

          /* setTimeout(() => {
            localStorage.setItem('firstIndex', 12227);
          }, 1000); */
        } else {
          const res1 = await api.getAuthTree();
          if (res1) {
            res1.isPurchase = false;
            if (nanJingWhiteData) {
              // 配置南京白名单，直接存储
              context.commit('update_menuInfo', res1.data);
            } else {
              // 没配置南京白名单，剔除
              const menuData = whiteUtils.isPurchaseDealNanJingWhite(res1.data);
              context.commit('update_menuInfo', menuData);
            }
          }
        }

        /* let res2 = await api.getAllMeunList();
        localStorage.setItem('meunList', res2.data); */
      }
    } else {
      router.push({
        path: '/ssologin',
      });
    }
  },

  async handleSubItem({ commit }, params) {
    const res = await api_authority.queryBackButton({ authCode: params });
    commit('button_directive', res.data);
  },

  moduleBelong({ commit }, params) {
    commit('moduleBelong_tag', params);
  },

  async setPVUV({ commit }, payload) {
    const { fullPath, code, name } = payload;
    const { userAgent } = navigator;
    const { hostname } = window.location;
    let uuid = '';
    if (VueCookies.get('uuidAddress')) {
      uuid = VueCookies.get('uuidAddress');
    } else {
      uuid = createKey();
      VueCookies.set('uuidAddress', uuid, {
        path: '/',
        domain: '.epec.com',
        secure,
      });
    }

    const params = {
      eventType: 1,
      pageNo: code, // 易专采首页code是 ?
      fullPath, // 完整路径
      macAddress: uuid,
      userAgent,
      createTime: timestampToTime(new Date().getTime()),
      eventParam: name, // 页面的名字
      contextInfo: name, // 页面的名字
      pathDomain: hostname,
      createDay: getDate(),
    };
    const result = await Api.setPVUV(params);
  },
};
